import { LoadingStateWithIdle } from "../../data-layer/loading-state-with-idle";
import { GetCartResponseT } from "../get-cart";
import { useCallback, useEffect, useState } from "react";
import { useStore } from "../../../store/hooks/use-store";

export function useUnauthorisedPanicMode(
  _fetchedCart: LoadingStateWithIdle<{ result: GetCartResponseT }>,
  token: string | undefined,
) {
  const [raisedForToken, setRaisedForToken] = useState<string | null>(null);
  const { dispatch } = useStore();

  const onUnauthorized = useCallback(() => {
    dispatch({ type: "token-appears-to-be-invalid" });
  }, [dispatch]);

  if (
    typeof token === "string" &&
    _fetchedCart.__tag === "loaded" &&
    _fetchedCart.data.result._tag === "Left" &&
    _fetchedCart.data.result.left === "unauthorised"
  ) {
    if (raisedForToken !== token) {
      onUnauthorized();
      setRaisedForToken(token);
    }
  }
}
